import React from 'react';
import ReactDOM from 'react-dom';
import { createReducer } from './reducers';
import './Server/Redux.server';
import './Components/Vanilla';
import './Server/expose-react';
import store from './store';
import '../styles/main.css';
import { Provider } from 'react-redux';

const hydrateServerComponents = () => {
  import('./Server/expose-components').then(() => {
    const reactLoadedEvent = new Event('ReactLoaded');
    window.dispatchEvent(reactLoadedEvent);

    // Remove hydration script tag
    document.getElementById('ssr-hydration-script').remove();
  });
};

window.__litium = window.__litium || {};

// Add a dictionary to keep track of the registered async reducers
global.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
global.injectReducer = (key, asyncReducer) => {
  if (!global.asyncReducers[key]) {
    global.asyncReducers[key] = asyncReducer;
    store.replaceReducer(createReducer(global.asyncReducers));
  }
};

window.__litium = {
  ...window.__litium,
  bootstrapComponents: () => {
    // bootstrap React components, in case the HTML response we receive from the server
    // has React components. ReactDOM.render performs only an update on previous rendered
    // components and only mutate the DOM as necessary to reflect latest React element.
    bootstrapComponents();
  },
  cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
  registeredContainers.push(container);
  ReactDOM.render(element, container, callback);
};

const bootstrapComponents = () => {
  const reactElements = document.querySelectorAll(
    '[data-react-component]'
  );

  import('./Server/expose-components').then(() => {
    for (let elem of reactElements) {
      let componentName = elem.dataset['reactComponent'];

      if (!componentName) {
        console.warn(
          'A react component div was found, but no react component was specified',
          elem
        );
        continue;
      }

      let dataJson = elem.querySelector('json-data')?.innerText;
      let data = dataJson ? JSON.parse(dataJson) : {};
      const Component = global['Components'][componentName];
      if (!Component) {
        console.warn('Could not find component ' + componentName);
        continue;
      }

      renderReact(
        <Provider store={store}>
          <Component {...data} />
        </Provider>,
        elem,
        () => {
          elem.removeAttribute('style');
          const tempClassName = elem.dataset['tempClassName'];
          if (tempClassName) {
            elem.classList.remove(tempClassName);
          }
        }
      );
    }

    hydrateServerComponents();
  });
};

bootstrapComponents();
